export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig().public;

  if (config.MOCK_SERVER === 'true') {
    await import('@/apis/mocks/Worker').then(async ({ worker }) => {
      await worker.start();
    });
  }
});
